import classNames from "classnames";

export const VerticalDivider = ({ size = "small" }: { size?: string }) => (
  <div
    className={classNames(`t-w-[1px] t-bg-neutral-20`, {
      "t-h-[0.9rem]": size === "small",
      "t-h-4": size === "medium",
      "t-h-6": size === "large",
      "t-h-[21px]": size === "xmedium",
      "t-h-[10px]": size === "xsmall",
    })}
  ></div>
);
